import { registerDe } from '../i18n/index.js';

registerDe({
  'Inbox': 'Posteingang',
  'every thread is a touchpoint': 'jeder Verlauf ist ein Kontaktpunkt',
  'synced': 'synchronisiert',
  'IMAP idle': 'IMAP im Ruhezustand',
  'drop folder only': 'nur Ablageordner',
  'sender in stub mode · approved mail is written to {dir}':
    'Versand im Stub-Modus · freigegebene Mail wird nach {dir} geschrieben',
  'sender is SMTP · approved mail actually leaves': 'Versand per SMTP · freigegebene Mail geht tatsächlich raus',
  'the sender has not answered yet': 'der Versand hat noch nicht geantwortet',

  // rail
  'Needs me': 'Braucht mich',
  'threads whose last message came in and is unanswered':
    'Verläufe, deren letzte Nachricht einging und unbeantwortet ist',
  'Unknown': 'Unbekannt',
  '{n} with a domain that matches an organisation': '{n} mit einer Domain, die zu einer Organisation passt',
  'Drafts': 'Entwürfe',
  'held proposals waiting for a send': 'übernommene Vorschläge, die auf den Versand warten',
  'Outbox': 'Ausgang',
  'stub': 'Stub',
  'written to data/outbox/, not sent': 'nach data/outbox/ geschrieben, nicht gesendet',
  'sent through SMTP': 'per SMTP gesendet',
  'Threads · 7d': 'Verläufe · 7 T',
  '{in} in · {out} out · median reply {h}': '{in} ein · {out} aus · mittlere Antwort {h}',
  'the summary has not answered yet': 'die Zusammenfassung hat noch nicht geantwortet',
  'Unknown senders': 'Unbekannte Absender',

  // the panes
  'The mailbox': 'Das Postfach',
  'The mailbox could not be read': 'Das Postfach konnte nicht gelesen werden',
  'All': 'Alle',
  '{n} message': '{n} Nachricht',
  '{n} messages': '{n} Nachrichten',
  'unknown': 'unbekannt',
  'unknown sender': 'unbekannter Absender',
  '(no subject)': '(kein Betreff)',
  'us · late': 'wir · überfällig',
  'No sender is waiting for a judgement.': 'Kein Absender wartet auf eine Entscheidung.',
  'Nothing is waiting on you. Every thread was last answered by you.':
    'Nichts wartet auf Sie. Jeden Verlauf haben zuletzt Sie beantwortet.',
  'No mail has been imported yet. Drop an .eml into the drop folder, or configure MAIL_IMAP_HOST.':
    'Es wurde noch keine Mail importiert. Legen Sie eine .eml in den Ablageordner oder setzen Sie MAIL_IMAP_HOST.',
  'Choose a thread on the left.': 'Wählen Sie links einen Verlauf.',
  'The thread could not be read': 'Der Verlauf konnte nicht gelesen werden',

  // triage
  'Unknown sender': 'Unbekannter Absender',
  'matches': 'passt zu',
  'by domain': 'über die Domain',
  'matches no organisation on the record': 'passt zu keiner erfassten Organisation',
  'Create person': 'Person anlegen',
  'Attach to existing…': 'Bestehender Person zuordnen…',
  'Attach to an existing person': 'Bestehender Person zuordnen',
  'Ignore domain': 'Domain ignorieren',
  'Name, organisation, email…': 'Name, Organisation, E-Mail…',
  'Type at least two characters.': 'Geben Sie mindestens zwei Zeichen ein.',
  'No person matches that.': 'Dazu passt keine Person.',
  'This address has written {n} times since {date}. Nothing about it has entered the record: no person, no interaction. Creating a person files a proposal in your name and holds it in the same click, so the ledger says who decided.':
    'Diese Adresse hat seit {date} {n}-mal geschrieben. Nichts davon ist erfasst: keine Person, kein Kontaktpunkt. „Person anlegen“ legt einen Vorschlag in Ihrem Namen an und übernimmt ihn im selben Klick, damit das Protokoll festhält, wer entschieden hat.',
  'Person created and the thread linked.': 'Person angelegt und der Verlauf verknüpft.',
  'The address is now on {name}.': 'Die Adresse gehört jetzt zu {name}.',
  'The domain is ignored.': 'Die Domain wird ignoriert.',

  // the thread
  'messages': 'Nachrichten',
  'ball · us': 'Ball · wir',
  'ball · them': 'Ball · sie',
  'd': 'T',
  '(this message carried no text part)': '(diese Nachricht hatte keinen Textteil)',
  'Draft reply': 'Antwortentwurf',
  'words': 'Wörter',
  'Send (stub)': 'Senden (Stub)',
  'Send': 'Senden',
  'Amend in Review →': 'In der Prüfung anpassen →',
  'Amend →': 'Anpassen →',
  'writes an .eml into data/outbox/ and marks the row written':
    'schreibt eine .eml nach data/outbox/ und markiert die Zeile als geschrieben',
  'leaves through SMTP and marks the row sent': 'geht per SMTP raus und markiert die Zeile als gesendet',
  'The message was written to the outbox.': 'Die Nachricht wurde in den Ausgang geschrieben.',

  // zones
  'Drafts to approve': 'Entwürfe zur Freigabe',
  'held proposals · nothing here has been sent': 'übernommene Vorschläge · nichts davon wurde gesendet',
  'Review →': 'Prüfung →',
  'No draft is waiting': 'Kein Entwurf wartet',
  'A row appears here when you hold a `draft` proposal: the applier writes one outbox row, status approved. Holding a draft is not sending it — sending is the button on the row.':
    'Eine Zeile erscheint hier, sobald Sie einen `draft`-Vorschlag übernehmen: Der Applier schreibt genau eine Ausgangszeile mit Status „freigegeben“. Übernehmen ist nicht Senden — gesendet wird über die Schaltfläche in der Zeile.',
  'Outbox and sent': 'Ausgang und Gesendet',
  'stub sender · nothing left this machine': 'Stub-Versand · nichts hat diese Maschine verlassen',
  'SMTP sender': 'SMTP-Versand',
  'Subject': 'Betreff',
  'To': 'An',
  'Status': 'Status',
  'Sent': 'Gesendet',
  'File': 'Datei',
  'written': 'geschrieben',
  'sent': 'gesendet',
  'failed': 'fehlgeschlagen',
  'approved': 'freigegeben',
  'Nothing has been sent': 'Es wurde nichts gesendet',
  'A row lands here after you send an approved draft. With the stub sender the bytes are written to data/outbox/ and the row reads written, not sent — the difference is the point.':
    'Eine Zeile landet hier, nachdem Sie einen freigegebenen Entwurf gesendet haben. Mit dem Stub-Versand werden die Bytes nach data/outbox/ geschrieben und die Zeile liest „geschrieben“, nicht „gesendet“ — genau darauf kommt es an.',
  'Reading the thread — what it finds arrives in Review.':
    'Der Thread wird gelesen — was dabei gefunden wird, erscheint in der Prüfung.',
}, 'InboxPage');
